export default "__VITE_PUBLIC_ASSET__988b1f99__"